export const AReferencesSwiperNav = () => (
	<div className='swiper_controls_buttons hide_lgm'>
		<button
			className='btn_circle toleft references-prev cursornodrag'
			name='predchadzajuci'
			title='Predchádzajúci'
			type='button'
		>
			<span>
				<svg className='sico'>
					<use href='/assets/layout/icons.svg#s_ar2_l' />
				</svg>
			</span>
			<span>
				<svg className='sico'>
					<use href='/assets/layout/icons.svg#s_ar2_l' />
				</svg>
			</span>
		</button>

		<button
			className='btn_circle references-next cursornodrag'
			name='nasledujuci'
			title='Následujúci'
			type='button'
		>
			<span>
				<svg className='sico'>
					<use href='/assets/layout/icons.svg#s_ar2_r' />
				</svg>
			</span>
			<span>
				<svg className='sico'>
					<use href='/assets/layout/icons.svg#s_ar2_r' />
				</svg>
			</span>
		</button>
	</div>
)
